import { type InstallSourceContext } from '@/lib/analytics/install-source-context';
import { atom } from 'jotai';

/**
 * Resolved install-source context (installer type, distribution channel,
 * normalized MDM provider), or `null` until the flag-gated orchestrator runs.
 * Always `null` on web and on-prem.
 *
 * Bridges the analytics orchestrator (`applyInstallSourceContext`) to
 * `OpenFeatureContextSync`, which reads it to set the `distribution_channel` /
 * `mdm_provider` Flagsmith traits, and to any downstream consumers. Because the
 * atom is only populated when `release-apps-install-source-tracking-desktop` is
 * on, the flag gate transitively controls the traits too (APP-5958).
 */
export const installSourceContextAtom = atom<InstallSourceContext | null>(null);
